import React from 'react';
import { AnalysisIcon, dimensionToCategory } from './constants';
import { Button, Tooltip } from 'antd';
import { track } from '@utils';
import { CLICK_DRILL_DOWN_ICON } from '@src/utils/sensor/track';
export * from './utils';
export * from './hooks';

const getDrillDownIcon = (): JSX.Element => {
  return <AnalysisIcon fill="white" />;
};
/**
 * Drill down to perset Event Scope, take along with current global filter and dimension filter with current value.
 */
export const DrillDownToEventScope: React.FC<{
  dimension: string;
  handleAction: () => void;
}> = ({ dimension, handleAction }) => {
  const category = dimensionToCategory[dimension];
  let title = '';
  if (category === 'events') {
    title = 'Drill down to Events view';
  }
  if (category === 'network') {
    title = 'Drill down to Service Performance view';
  }

  const handleClick = () => {
    track({
      event: CLICK_DRILL_DOWN_ICON,
      data: { tooltip: title },
    });
    handleAction();
  };

  return (
    <Tooltip title={title}>
      <Button
        type="text"
        style={{
          backgroundColor: '#0046ff',
          color: 'white',
          width: '40px',
        }}
        icon={getDrillDownIcon()}
        onClick={handleClick}
      />
    </Tooltip>
  );
};
